import { TimeDisplay } from "./time.filter";
import { DebugLog } from "@me8eon/debug";
import { FiltersPlugin } from "@me8eon/filters/src/filters.plugin";


export const timefilterPluginName = "time";
export type TimeString = "yesterday" | "lastWeek" | "lastMonth" | "lastYear"
export const timeStrings: TimeString[] = ["yesterday", "lastWeek", "lastMonth", "lastYear"];

export type TimeFilters = {
    [timefilterPluginName]: TimeString | undefined
}


export const timeFilterPlugin: FiltersPlugin<TimeFilters, "time"> = {
    plugin: "filter",
    type: timefilterPluginName,
    DefaultDisplay: TimeDisplay,
    changeCausesSubmit: true,
    deleteWhenClean: true,
    fromUrl: (debug: DebugLog, urlData, def) => {
        const time = urlData.url.searchParams.get(timefilterPluginName) || def;
        if (!timeStrings.includes(time as TimeString)) {
            debug("timeFilter fromUrl", "time=", time, `and it is not in ${timeStrings} so defaulting to`, def);
            return def;
        }
        debug("timeFilter fromUrl", "time=", time);
        return time as TimeString || def;
    },
    addToUrl: (debug, sp, time) => {
        debug("timeFilter addToUrl", "time=", time);
        if (time && timeStrings.includes(time as TimeString))
            sp.set(timefilterPluginName, time);
        else
            sp.delete(timefilterPluginName);
    },
};